import axios from "axios";
import { baseApiUrl, httpRequest, getHttpHeaders } from "../ApiUtils";


const answerApiUrl = `${baseApiUrl}/api/Answer`;

export async function getAnswer() {
    return await httpRequest(fetchAnswer.bind(this));
}

async function fetchAnswer() {
    let config = getHttpHeaders();
    return await axios.get(`${answerApiUrl}`, config);
}

export async function getAnswerById(id) {
    return await httpRequest(fetchAnswerById.bind(this, id));
}

async function fetchAnswerById(id) {
    let config = getHttpHeaders();
    return await axios.get(`${answerApiUrl}/${id}`, config);
}

export async function getQuizQuestionsAnswers(employeeFollowUpEventId) {
    return await httpRequest(getQuizQuestionsAnswersHttp.bind(this, employeeFollowUpEventId));
}

async function getQuizQuestionsAnswersHttp(employeeFollowUpEventId) {
    let config = getHttpHeaders();
    return await axios.get(`${answerApiUrl}/quiz-questions-answers?employeeFollowUpEventId=${employeeFollowUpEventId}`, config);
}

export async function getConsultantQuizQuestions(employeeFollowUpEventId) {
    return await httpRequest(getConsultantQuizQuestionsHttp.bind(this, employeeFollowUpEventId));
}
async function getConsultantQuizQuestionsHttp(token) {
    let config = getHttpHeaders();
    return await axios.get(`${answerApiUrl}/consultant-quiz?token=${token}`, config);
}

export async function consultantQuizAnswers(answers) {
    return await httpRequest(consultantQuizAnswersHttp.bind(this, answers));
}
async function consultantQuizAnswersHttp(answers) {
    let config = getHttpHeaders();
    return await axios.post(`${answerApiUrl}/consultant-quiz-answers`, answers, config);
}